import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed z-50 flex items-center justify-center w-full h-screen bg-gray-500 bg-opacity-50 pointer-events-none frm-spinner" }
const _hoisted_2 = { class: "flex items-center p-5 bg-white rounded-full shadow-md" }

import { IonSpinner } from '@ionic/vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'PageLoader',
  setup(__props) {

   
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(IonSpinner), { name: "circles" }),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "px-2 text-sm font-bold text-l animate-pulse" }, [
          _createTextVNode(" Loading"),
          _createElementVNode("span", { class: "inline-flex" }, "...")
        ], -1))
      ])
    ])
  ]))
}
}

})